const joinPaths = (...paths) => paths.filter(path => path).join('.')

export default joinPaths
